var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-action-btn',{attrs:{"access":_vm.canModifyTableRows(_vm.role),"icon-src":require('@/assets/icons/delete-icon.svg'),"img-class":"inverted-icon","show-tooltip":!_vm.canModifyTableRows(_vm.role),"top":""},on:{"click":function($event){_vm.canModifyTableRows(_vm.role).allowed && _vm.askAndPerform(_vm.rowsDeleteAction, _vm.getRemoveText)({
    tableType: _vm.tableType,
    rowId: _vm.rowId,
    projectId: _vm.$route.params.id
  })}}},[_vm._v(" Delete ")])}
var staticRenderFns = []

export { render, staticRenderFns }